import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CheckBoxSelector } from '../checkbox-selector/checkbox-selector.component';

@Component({
  selector: 'app-sort-arrow',
  templateUrl: './sort-arrow.component.html',
  styleUrls: ['./sort-arrow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortArrowComponent implements OnChanges {
  @Input() count = -1; // counter to define current state of sort arrow in html
  @Input() field: string; // field that u want to sort
  @Input() title: string; // title that will be displayed in ur TH
  @Input() showSearchIcon = false;
  @Input() shouldCancelSearch: boolean;
  @Input() useCheckBox = false;
  @Input() checkBoxItems: CheckBoxSelector[];
  @Input() searchIconDataQa = 'search-icon';
  @Output() onchange = new EventEmitter<string>();
  @Output() sortCompanyByFieldEmitter = new EventEmitter<string>();
  @Output() showSearchEmitter = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<boolean>();

  showFilterDropDown = false;
  showCheckboxSelector = false;
  showIconUp = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.shouldCancelSearch) {
      this.showFilterDropDown = false;
    }
  }

  emitField(): void {
    if (this.showFilterDropDown) {
      return;
    }
    this.showIconUp = false;
    this.showFilterDropDown = false;
    this.sortCompanyByFieldEmitter.emit(this.field);
  }

  emitSearch(): void {
    if (this.showFilterDropDown) {
      return;
    }
    this.showSearchIcon = false;
    this.showSearchEmitter.emit();
    if (this.useCheckBox) {
      this.showCheckboxSelector = true;
    } else {
      this.showFilterDropDown = true;
    }

  }

  emitChanges(value: string): void {
    this.onchange.emit(value);
    this.showSearchIcon = true;
  }

  close(): void {
    this.showFilterDropDown = false;
    this.showSearchIcon = true;
    this.cancel.emit(true);

  }

}
export interface ColumnSort {
  field: string;
  counter: number;
  /**
   * create array with this type and fill it in order as u have order in urr columns define counter for 0 in
   * for position if u fetch already sorted data
   * example:   this.sortArray.push({ field: 'name', counter: 0 }); current data already sorted by field name
    this.sortArray.push({ field: 'country', counter: -1 });
    this.sortArray.push({ field: 'industry', counter: -1 });
   */
}

export interface DisableColumnsWithBulkFill {
  field: string;
  disabled: boolean;
}
